import type { SVGProps } from 'react';
export const Stock = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M10.76 4.52a5 5 0 0 0-3.1.32 5.4 5.4 0 0 0-2.4 2.05 5.8 5.8 0 0 0 0 6.22 5.4 5.4 0 0 0 2.4 2.05 5.2 5.2 0 0 0 5.85-1.21c.26-.28.7-.28.96 0 .26.27.26.72 0 1a6.47 6.47 0 0 1-7.32 1.52 7 7 0 0 1-3.02-2.58 7.2 7.2 0 0 1 0-7.78 7 7 0 0 1 3.02-2.58 6.5 6.5 0 0 1 7.32 1.52l1.18 1.23V4.54c0-.39.3-.7.67-.7a.7.7 0 0 1 .68.7v3.44c0 .39-.3.7-.68.7h-3.3a.7.7 0 0 1-.67-.7c0-.4.3-.71.68-.71h1.65l-1.17-1.22a5.3 5.3 0 0 0-2.75-1.53"
      clipRule="evenodd"
    />
  </svg>
);
